/**
 * 微信公众号用的http请求工具
 */
import http from './http';

let wechatHttp = {
    post: "",
    get: ""
}

/**
 * post 请求
 */
wechatHttp.post = function (options) {
    options["wechatHttpFlag"] = true;
    http.post(options);
}

/**
 * get 请求
 */
wechatHttp.get = function (options) {
    options["wechatHttpFlag"] = true;
    http.get(options);
}

export default wechatHttp;